import { priceField } from '../../../table/CommonFields';
import { roundHalfUp } from '../../../../helpers/numberUtils';

// Pola formularza
const fields = {
  config: { columns: 1 },
  fields: [
    {
      name: 'beforeDiscount',
      type: 'unvisible',
      column: 1,
    },
    {
      name: 'description',
      label: 'Opis',
      mandatory: true,
      column: 1,
    },
    // // priceField(1, 'beforeDiscount', 'Przed rabatem', true),
    // withAutocomplete(priceField(1, 'value', 'Wylicz dla kwoty', false), {
    //   triggers: ['beforeDiscount', 'discountPercentage'],
    //   calculation: function (beforeDiscount, percentage) {
    //     const bd = parseFloat(beforeDiscount);
    //     const pct = parseFloat(percentage);
    //
    //     if (!isNaN(bd) && !isNaN(pct)) {
    //       const result = (bd * pct) / 100;
    //       return Number(roundHalfUp(result, 2));
    //     }
    //
    //     return '';
    //   },
    // }),
    // priceField(1, 'beforeDiscount', 'Przed rabatem', true),
    priceField(1, 'value', 'Wylicz dla kwoty', false),
    {
      name: 'discountPercentage',
      label: 'Rabat %',
      column: 1,
      suffix: '%',
      maxValue: 100,
      minValue: 0,
      scale: 5,
      validate: function (value) {
        const parsed = parseFloat(value);
        return !isNaN(parsed) && parsed > 0;
      },
      defaultValue: '0',
      mandatory: true,
      type: 'number',
      autoComplete: {
        triggers: ['beforeDiscount', 'value'],
        calculation: function (beforeDiscount, discountAmount) {
          const bd = parseFloat(beforeDiscount);
          const da = parseFloat(discountAmount);

          if (!isNaN(bd) && bd > 0 && !isNaN(da) && da <= bd) {
            const percentage = (da / bd) * 100;
            return Number(roundHalfUp(percentage, 5));
          }

          return ''; // jeśli wartość rabatu większa niż przed rabatem — nic nie wpisuj
        },
      },
    },
    // withAutocomplete(priceField(1, 'afterDiscount', 'Po rabacie', true), {
    //   triggers: ['beforeDiscount', 'value'],
    //   calculation: function (beforeDiscount, discount) {
    //     const bd = parseFloat(beforeDiscount);
    //     const d = parseFloat(discount);
    //
    //     if (!isNaN(bd) && !isNaN(d)) {
    //       const result = bd - d;
    //       return Number(result.toFixed(2));
    //     }
    //
    //     return '';
    //   },
    // }),
  ],
};

export default fields;
